// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import React from 'react';
import { useLocale } from '../localization';
import { ControlBarButton } from './ControlBarButton';
import { Icon } from '@fluentui/react';
const onRenderMicOnIcon = () => React.createElement(Icon, { iconName: "ControlButtonMicOn" });
const onRenderMicOffIcon = () => React.createElement(Icon, { iconName: "ControlButtonMicOff" });
/**
 * A button to turn microphone on / off.
 *
 * Can be used with {@link ControlBar}.
 *
 * @public
 */
export const MicrophoneButton = (props) => {
    var _a, _b, _c, _d;
    const localeStrings = useLocale().strings.microphoneButton;
    const strings = Object.assign(Object.assign({}, localeStrings), props.strings);
    return (React.createElement(ControlBarButton, Object.assign({}, props, { onClick: (_a = props.onToggleMicrophone) !== null && _a !== void 0 ? _a : props.onClick, onRenderOnIcon: (_b = props.onRenderOnIcon) !== null && _b !== void 0 ? _b : onRenderMicOnIcon, onRenderOffIcon: (_c = props.onRenderOffIcon) !== null && _c !== void 0 ? _c : onRenderMicOffIcon, strings: strings, labelKey: (_d = props.labelKey) !== null && _d !== void 0 ? _d : 'microphoneButtonLabel' })));
};
//# sourceMappingURL=MicrophoneButton.js.map